export default {
  'menu.home': 'Biểu đồ thống kê',
  'menu.post-management': 'Quản lý bài viết',
  'menu.post-management.list': 'Danh sách bài viết',
  'menu.post-management.category': 'Danh mục bài viết',
  'menu.post-management.add': 'Tạo bài viết',
  'menu.post-management.edit': 'Sửa bài viết',
  'menu.service-management': 'Quản lý dịch vụ',
  'menu.customer-management': 'Quản lý khách hàng',
  'menu.customer-management.list': 'Danh sách khách hàng',
  'menu.customer-management.detail': 'Lịch sử đặt vé',
  'menu.staff-management': 'Quản lý CBCNV',
  'menu.staff-management.list': 'Danh sách nhân viên',
  'menu.staff-management.role': 'Danh sách chức vụ',
  'menu.interface-management': 'Quản lý giao diện',
  'menu.interface-management.banner': 'Quản lý banner',
  'menu.login': 'Đăng nhập',
  'menu.exception.404': 'Không tìm thấy',
  'menu.ticket-management': 'Quản lý vé',
  'menu.feedback-management': 'Quản lý phản hồi',
  'menu.feedback-management.list': 'Danh sách phản hồi',
  'menu.law': 'Thư viện pháp luật',
  'menu.law.list': 'Bài viết dự thảo',
  'menu.law.list-1': 'Bài viết công văn',
  'menu.law.list-2': 'Bài viết Quyết định',
  'menu.chi-dao-dieu-hanh': 'Chỉ đạo điều hành',
  'menu.chi-dao-dieu-hanh.lich-tiep-cong-dan': 'Lịch tiếp công dân',
  'menu.chi-dao-dieu-hanh.van-ban-chi-dao': 'Văn bản chỉ đạo',
  'menu.chi-dao-dieu-hanh.thong-bao-khan': 'Thông báo khẩn',
  'menu.dan-cu-doi-song.lich-tiem-chung': 'Lịch tiêm chủng',
  'menu.dan-cu-doi-song.lich-cat-dien-nuoc': 'Lịch cắt điện nước',
  'menu.dan-cu-doi-song.tin-tuyen-dung': 'Tin tuyển dụng',
  'menu.dan-cu-doi-song': 'Dân cư - Đời sống',
  'menu.van-hoa-xa-hoi': 'Văn hóa - Xã hội',
  // Travel Management
  'menu.travel-management': 'Bản đồ du lịch',
  'menu.travel-management.list': 'Danh sách địa điểm',
  'menu.travel-management.add': 'Thêm địa điểm',
  'menu.travel-management.edit': 'Sửa địa điểm',
  // Planning Management
  'menu.planning-management': 'Bản đồ quy hoạch',
  'menu.planning-management.list': 'Danh sách layer',
  'menu.planning-management.add': 'Thêm layer',
  'menu.planning-management.edit': 'Sửa layer',
  'menu.question-management': 'Quản lý câu hỏi',
  'menu.question-management.list': 'Danh sách câu hỏi',
};
